import React from 'react';
import './css/ImpactSection.css';

const ImpactSection = ({ impact }) => {
 
    const description = typeof impact?.description === 'string' && impact.description.trim() !== ''
        ? impact.description
        : "No impact description available.";

    const items = Array.isArray(impact?.items) ? impact.items : [];

    return (
        <section className="impact-section" data-voices-theme="dark">
            <div className="container">
                <h2>What our impact looks like</h2>

                <div className="blogCountUpSection">
                    <div className="blogCountUpSection__wrapper">

                        <div className="blogCountUpSection__left">
                            <h2 style={{ color: '#fff', fontSize: "1.7rem", fontWeight: "200", lineHeight: "1.5", letterSpacing: '1px' }}>
                                {description}
                            </h2>
                        </div>

                        <div className="blogCountUpSection__right">
                            {items.length > 0 ? (
                                items.map((item, index) => {
                                    const id = item?.id || index;
                                    const measure = typeof item?.measure === 'string' ? item.measure : '';
                                    const title = typeof item?.title === 'string'
                                        ? item.title
                                        : (typeof item?.name === 'string' ? item.name : 'No title');

                                    return (
                                        <div className="impact_count_section">
                                            <h3 className=" " style={{ color: '#fff' }}>{measure}</h3>
                                            <p style={{ color: '#fff !important' }}>{title}</p>
                                        </div>
                                    );
                                })
                            ) : (
                                <p>No impact items to display.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ImpactSection;
